import T, { t } from '../../common/components/T';

export const checkUserToken = (data, afterConfirm, setAllowedSend, setUserToken, setAlertData, translation) => {
    const token = data?.data?.token;

    if (token) {
        setUserToken(token);
        afterConfirm && afterConfirm(token);
    } else {
        setAlertData({
            type: 'error',
            cont: t('authentication', 'Неверный токен', '/authentication', translation)
        });
        setAllowedSend(true);
    }

    return true;
};

export const getTabs = (type) =>
    type === 'register'
        ? [
              {
                  tabName: <T textName='register_enter' defaultStr='Регистрация' page='/authentication' />,
                  alias: 'register',
                  routeData: {
                      asRout: '/auth/register'
                  }
              }
          ]
        : [
              {
                  tabName: <T textName='login_tab' defaultStr='Авторизация' page='/authentication' />,
                  alias: 'login',
                  routeData: {
                      asRout: '/store'
                  }
              }
          ];

export const storeTabs = [
    {
        tabName: <T textName='login_tab' defaultStr='Авторизация' page='/authentication' />,
        alias: 'login',
        routeData: {
            asRout: 'login'
        }
    },
    {
        tabName: <T textName='register_enter' defaultStr='Регистрация' page='/authentication' />,
        alias: 'register',
        routeData: {
            asRout: 'register'
        }
    }
];
